<template>
  <li>
    <a
      v-if="link.isAnchorLink"
      :href="link.routeName"
      class="text link hover:text-primary"
    >
      {{ $t(link.title) }}
    </a>
    <router-link
      v-else-if="!link.isOuterLink"
      :to="{ path: link.routeName }"
      class="text link md:hover:text-primary"
    >
      {{ $t(link.title) }}
    </router-link>
    <a
      v-else
      :href="link.routeName"
      class="text link hover:text-primary"
      target="_blank"
    >
      {{ $t(link.title) }}
    </a>
  </li>
</template>

<script setup>
defineProps({
  link: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss" scoped></style>
